/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export default class WorkflowsTroubleshootConversationEventRoute extends ReactRoute(Route) {
  analytics = {
    place: 'workflows_troubleshoot_conversation_event',
    section: 'automation',
  };

  reactEnabled(): boolean {
    return true;
  }
}
